import { c as _c } from "react/compiler-runtime";
import React from 'react';
const IconPremiumDelivery = t0 => {
  const $ = _c(17);
  const {
    className: t1,
    color: t2,
    height: t3,
    width: t4
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const color = t2 === undefined ? "#27919C" : t2;
  const height = t3 === undefined ? "34" : t3;
  const width = t4 === undefined ? "34" : t4;
  let t10;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== color) {
    t5 = <g><polyline stroke={color} fill="none" strokeLinejoin="round" strokeWidth="15px" points="135.9 220.18 175.55 182.37 135.9 144.56" /><line stroke={color} fill="none" strokeLinejoin="round" strokeWidth="15px" x1="175.55" y1="182.37" x2="100.48" y2="182.37" /></g>;
    t6 = <rect stroke={color} fill="none" strokeLinejoin="round" strokeWidth="15px" x="100.48" y="270.67" width="141.64" height="113.29" />;
    t7 = <polygon stroke={color} fill="none" strokeLinejoin="round" strokeWidth="15px" points="399.52 367.34 243.9 389.7 243.9 110.3 399.52 132.66 399.52 367.34" />;
    t8 = <ellipse fill={color} cx="275.77" cy="250.76" rx="11.55" ry="11.63" />;
    t9 = <rect stroke={color} fill="none" strokeLinejoin="round" strokeWidth="15px" x="159.22" y="270.67" width="24.14" height="39.11" />;
    t10 = <path fill={color} d="M205,110.3c-3.14,0-5.68,2.56-5.68,5.73v154.64h42.8l1.79-160.36h-38.9Z" />;
    $[0] = color;
    $[1] = t10;
    $[2] = t5;
    $[3] = t6;
    $[4] = t7;
    $[5] = t8;
    $[6] = t9;
  } else {
    t10 = $[1];
    t5 = $[2];
    t6 = $[3];
    t7 = $[4];
    t8 = $[5];
    t9 = $[6];
  }
  let t11;
  if ($[7] !== className || $[8] !== height || $[9] !== t10 || $[10] !== t5 || $[11] !== t6 || $[12] !== t7 || $[13] !== t8 || $[14] !== t9 || $[15] !== width) {
    t11 = <svg viewBox="0 0 500 500" xmlns="http://www.w3.org/2000/svg" version="1.1" width={width} height={height} className={className}>{t5}{t6}{t7}{t8}{t9}{t10}</svg>;
    $[7] = className;
    $[8] = height;
    $[9] = t10;
    $[10] = t5;
    $[11] = t6;
    $[12] = t7;
    $[13] = t8;
    $[14] = t9;
    $[15] = width;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  return t11;
};
export default IconPremiumDelivery;